'use client';

import { c as _c } from "react/compiler-runtime";
import type { IdentityProvidersNames } from '@repo/api-gw-sdk';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { Loader } from '@/components/layout/loading';
import type { LoginHostKind } from '@/contexts/environment';
import { useEnvironment } from '@/contexts/useEnvironment';
import { useFeatureFlags, useLaunchDarkly } from '@/contexts/useFeatureFlags';
import { LoginV2DomainPage } from './login-v2/loginV2DomainPage';
import { LoginV2Page } from './login-v2/loginV2Page';
import { LoginPage } from './loginPage';
interface LoginSwitchProps {
  hostKind: LoginHostKind;
  hasAuthToken: boolean;
  hasError: boolean;
  idpData: IdentityProvidersNames;
}
export function LoginSwitch(props) {
  const $ = _c(7);
  const {
    LoginV2Enabled
  } = useFeatureFlags();
  const {
    isReady
  } = useLaunchDarkly();
  if (!isReady) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Loader />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const loginV2Enabled = LoginV2Enabled === true;
  let t0;
  if ($[1] !== loginV2Enabled || $[2] !== props.hasAuthToken || $[3] !== props.hasError || $[4] !== props.hostKind || $[5] !== props.idpData) {
    t0 = loginV2Enabled ? <LoginV2Branch hostKind={props.hostKind} hasAuthToken={props.hasAuthToken} idpData={props.idpData} /> : <LoginV1Branch hostKind={props.hostKind} hasError={props.hasError} />;
    $[1] = loginV2Enabled;
    $[2] = props.hasAuthToken;
    $[3] = props.hasError;
    $[4] = props.hostKind;
    $[5] = props.idpData;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
}
function LoginV1Branch(t0) {
  const $ = _c(8);
  const {
    hostKind,
    hasError
  } = t0;
  const {
    clientApiBaseUrl,
    isDev
  } = useEnvironment();
  const searchParams = useSearchParams();
  const shouldRedirect = hostKind === "public-tenant" && !hasError;
  let t1;
  let t2;
  if ($[0] !== clientApiBaseUrl || $[1] !== isDev || $[2] !== searchParams || $[3] !== shouldRedirect) {
    t1 = () => {
      if (!shouldRedirect) {
        return;
      }
      let url = `${clientApiBaseUrl}/login`;
      const returnUrl = searchParams.get("returnUrl");
      if (returnUrl && !isDev) {
        url = url + `?returnUrl=${returnUrl}`;
      }
      window.location.replace(url);
    };
    t2 = [shouldRedirect, clientApiBaseUrl, isDev, searchParams];
    $[0] = clientApiBaseUrl;
    $[1] = isDev;
    $[2] = searchParams;
    $[3] = shouldRedirect;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (shouldRedirect) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Loader />;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LoginPage />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function LoginV2Branch(t0) {
  const $ = _c(13);
  const {
    hostKind,
    hasAuthToken,
    idpData
  } = t0;
  const {
    isDev
  } = useEnvironment();
  const searchParams = useSearchParams();
  const router = useRouter();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("domain");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasDomain = Boolean(t1);
  const isPublicRoot = hostKind === "public-root";
  const redirectHome = !isPublicRoot && !isDev && hasAuthToken;
  let t2;
  let t3;
  if ($[2] !== redirectHome || $[3] !== router) {
    t2 = () => {
      if (redirectHome) {
        router.replace("/");
      }
    };
    t3 = [redirectHome, router];
    $[2] = redirectHome;
    $[3] = router;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (isPublicRoot) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <LoginV2DomainPage />;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  if (isDev) {
    let t4;
    if ($[7] !== hasDomain || $[8] !== idpData) {
      t4 = hasDomain ? <LoginV2Page idpData={idpData} /> : <LoginV2DomainPage />;
      $[7] = hasDomain;
      $[8] = idpData;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (redirectHome) {
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Loader />;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  let t4;
  if ($[11] !== idpData) {
    t4 = <LoginV2Page idpData={idpData} />;
    $[11] = idpData;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}